import { forwardRef } from "react";
import {
  Link as RouterLink,
  NavLink as RouterNavLink,
  type LinkProps,
  type NavLinkProps,
} from "react-router-dom";
// Scroll Craft owns document-level observers. Ordinary document navigation gives
// each page one engine lifecycle, and releases voice/audio on navigation.
export const Link = forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => (
  <RouterLink {...props} ref={ref} reloadDocument />
));
export const NavLink = forwardRef<HTMLAnchorElement, NavLinkProps>(
  (props, ref) => <RouterNavLink {...props} ref={ref} reloadDocument />,
);
Link.displayName = "Link";
NavLink.displayName = "NavLink";
